import React, { Component } from 'react'
import uniqid from 'uniqid'
import Select from 'react-select'
import { fromJS, updateIn, update } from 'immutable'

// import FamilyPartnersTwinModal from './family-partners-twin-modal'
// import FamilyPartnersAdoptedModal from './family-partners-adopted-modal'


import FamilyTreeSibling from './sibling'

class FamilyTreeProbandSiblings extends Component {

  render() {

    for(let sibling of this.props.proband_siblings) {
      sibling.gender = (sibling.gender === null) ? 'u' : sibling.gender
    }

    return <React.Fragment>

      {
        this.props.proband_siblings.filter(i => i.gender.toLowerCase() =='m').map((sibling, index) => {
          return <FamilyTreeSibling
            key={sibling.rkey}
            collapsed={true}
            label={'Brother #' + (index + 1) }
            sibling={sibling}
            parent_side='both'
            patient={this.props.patient}
            dispatch={this.props.dispatch}
            deleteMember={this.props.deleteMember}
          />
        })
      }

      {
        this.props.proband_siblings.filter(i => i.gender.toLowerCase() =='f').map((sibling, index) => {
          return <FamilyTreeSibling
            key={sibling.rkey}
            collapsed={true}
            label={'Sister #' + (index + 1) }
            sibling={sibling}
            parent_side='both'
            patient={this.props.patient}
            dispatch={this.props.dispatch}
            deleteMember={this.props.deleteMember}
          />
        })
      }

      {
        this.props.proband_siblings.filter(i => i.gender.toLowerCase() =='u').map((sibling, index) => {
          return <FamilyTreeSibling
            key={sibling.rkey}
            collapsed={true}
            label={'Sibling #' + (index + 1) }
            sibling={sibling}
            parent_side='both'
            patient={this.props.patient}
            dispatch={this.props.dispatch}
            deleteMember={this.props.deleteMember}
          />
        })
      }

    </React.Fragment>

  }
}

export default FamilyTreeProbandSiblings
